import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "d-flex align-items-center mt-3" }
const _hoisted_3 = { class: "vac-icon-search" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "row m-0 py-0 px-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Mostrar:")
], -1)
const _hoisted_7 = {
  class: "p-0",
  style: {"flex":"1"}
}

import { computed, ref, watch } from "vue";
import SvgIcon from "vue-advanced-chat/src/components/SvgIcon/SvgIcon.vue";
import { TicketModule } from "@/store/modules/Ticket";
import SelectControlled from "@/components/Inputs/SelectControlled.vue";
import { Filters } from "@/types/control";
import { AuthModule } from "@/store/modules/Auth";
import { EventInput } from "@fullcalendar/common";

// Props

export default /*#__PURE__*/_defineComponent({
  props: {
    textMessages: null,
    showSearch: { type: Boolean },
    showAddRoom: { type: Boolean }
  },
  emits: ["filter-room", "search-room", "add-room"],
  setup(__props: any, { emit: $emit }: { emit: ({
	(e: "filter-room", type: Filters): void;
	(e: "search-room", $event: any): void;
	(e: "add-room"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	textMessages: string;
	showSearch: boolean;
	showAddRoom: boolean;
}


// Emits


// Data
// eslint-disable-next-line no-undef
const handlerSearch = ref<NodeJS.Timeout | null>(null);
const filter = ref("claimed");

// computed
const showSearchBar = computed(() => {
	return props.showSearch || props.showAddRoom;
});
const showFilters = computed(
	() =>
		TicketModule.Filter !== Filters.OPEN &&
		TicketModule.Filter !== Filters.BOT &&
		TicketModule.Filter !== Filters.OVERVIEW
);

watch(
	() => TicketModule.Filter,
	() => {
		filter.value = TicketModule.Filter;
	}
);

function onChange(e: Filters) {
	$emit("filter-room", e);
}
function search(e: EventInput) {
	if (TicketModule.Filter !== Filters.CLOSED) return $emit("search-room", e);
	if (handlerSearch.value) clearTimeout(handlerSearch.value);
	handlerSearch.value = setTimeout(() => {
		TicketModule.resetSearch();
		TicketModule.requestPageTickets({
			token: AuthModule.token ?? "",
			query: e.target.value,
		});
	}, 500);
}

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
			'vac-box-search': _unref(showSearchBar),
			'vac-box-empty': !_unref(showSearchBar),
		})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.showSearch)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "search-icon", {}, () => [
                  _createVNode(SvgIcon, { name: "search" })
                ])
              ]),
              _createElementVNode("input", {
                id: "search-room-input",
                type: "search",
                placeholder: __props.textMessages,
                autocomplete: "off",
                class: "vac-input",
                onInput: search
              }, null, 40, _hoisted_4)
            ], 64))
          : _createCommentVNode("", true),
        (__props.showAddRoom)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "vac-svg-button vac-add-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($emit('add-room')))
            }, [
              _renderSlot(_ctx.$slots, "add-icon", {}, () => [
                _createVNode(SvgIcon, { name: "add" })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(showFilters))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(SelectControlled, {
                name: "type",
                placeholder: "Seleccione un filtro",
                "form-group-classes": "my-1 ml-2",
                options: [
							{
								label: 'Abiertos',
								value: 'claimed',
							},
							{
								label: 'Cerrados',
								value: 'closed',
							},
							{
								label: 'Archivados',
								value: 'archived',
							},
						],
                labelClasses: "text-muted h5 font-weight-normal",
                inputGroupClasses: "input-group shadow-none",
                value: filter.value,
                select: onChange,
                alternative: "",
                "select-options": {
							labelKey: 'label',
							valueKey: 'value',
							size: 'small',
							multiple: false,
						}
              }, null, 8, ["value"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_divider, {
        class: _normalizeClass(_unref(showFilters) ? 'my-0' : 'my-2')
      }, null, 8, ["class"])
    ])
  ], 2))
}
}

})